/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".register[_ngcontent-%COMP%]{display:flex;flex-direction:column}.register[_ngcontent-%COMP%]   .back[_ngcontent-%COMP%]{color:var(--primary-color,#50529f)!important}.register[_ngcontent-%COMP%]   .space-between[_ngcontent-%COMP%]{display:flex;justify-content:space-between}"];
export { styles as styles };
